import React from 'react';

export const AI = (props) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    viewBox="0 0 16 16"
    fill="none"
    {...props}
  >
    <path
      d="M6.42407 2.78299C6.79916 1.68531 8.3162 1.65196 8.76092 2.68314L8.79828 2.7836L9.30485 4.2635C9.42086 4.60298 9.60803 4.91408 9.8543 5.17496C9.86005 5.18105 9.86626 5.18669 9.87207 5.19272L12.9244 2.14043L12.9599 2.10797C13.1447 1.95728 13.4174 1.9682 13.5896 2.14043C13.7515 2.30234 13.7688 2.55164 13.6453 2.73459L2.3568 14.0237C2.33326 14.0473 2.31244 14.0729 2.29493 14.0997C2.11093 14.2795 1.81641 14.2784 1.634 14.096C1.45029 13.9123 1.45029 13.6145 1.634 13.4308L5.28413 9.78004C5.05506 9.55946 4.78606 9.38395 4.49089 9.26367L4.35552 9.21283L2.87562 8.70687C1.77732 8.33178 1.74398 6.81534 2.77517 6.37125L2.87562 6.33205L4.35552 5.8267C4.6949 5.71074 5.00554 5.52341 5.26637 5.27725C5.52718 5.03105 5.73253 4.73162 5.86789 4.39948L5.91873 4.2635L6.42407 2.78299Z"
      fill="currentColor"
    />
    <path
      d="M12.3486 6.33205C13.4462 6.70713 13.4795 8.22415 12.449 8.66889L12.3486 8.70626L10.8681 9.21283C10.5286 9.32874 10.2181 9.51614 9.95721 9.76228C9.69624 10.0085 9.4905 10.3078 9.35508 10.64L9.30485 10.776L8.79889 12.2565C8.42381 13.3542 6.90738 13.3875 6.46328 12.357L6.42407 12.2565L6.17722 11.5331L11.6252 6.08519L12.3486 6.33205Z"
      fill="currentColor"
    />
  </svg>
);
